/**
 * Formatting Utilities
 * Common formatting functions used across the application
 */

/**
 * Format seconds into a human-readable string (Xm Ys)
 */
export const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}m ${secs}s`;
};

/**
 * Format a date string to French locale
 */
export const formatDateFr = (dateString: string | null): string => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('fr-FR');
};

/**
 * Format a date string to French locale with time
 */
export const formatDateTimeFr = (dateString: string | null): string => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString('fr-FR');
};

/**
 * Calculate average from array of numbers
 */
export const calculateAverage = (values: number[]): number => {
  if (values.length === 0) return 0;
  return Math.round(values.reduce((sum, v) => sum + v, 0) / values.length);
};

/**
 * Get percentage color class based on value
 */
export const getPercentageColorClass = (percentage: number): string => {
  if (percentage >= 70) return 'bg-green-500';
  if (percentage >= 40) return 'bg-yellow-500';
  return 'bg-red-500';
};
